import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import store from 'store2';

import config from './config';
import Login from './common/auth/Login';
import Logout from './common/auth/Logout';
import Tv from './tv/Tv';
import Courses from './courses/Courses';
import Badges from './badges/Badges';
import AdminLayout from './common/layout/AdminLayout';
import Settings from './settings/Settings';
import MovementSpecialists from './movement-specialists/MovementSpecialists';
import Users from './users/Users';
import Library from './library/Library';
import GolfSchools from './golf-schools/GolfSchools';
import SwingSubmittals from './swing-submittals/SwingSubmittals';
import FollowUps from './follow-ups/FollowUps';

import 'cropperjs/dist/cropper.css';

export default () => {
  if (!store.get(config.auth.idTokenKey)) {
    return (
      <Switch>
        <Route exact path="/login" component={Login} />
        <Redirect to="/login" />
      </Switch>
    );
  }

  return (
    <AdminLayout>
      <Switch>
        <Route exact path="/logout" component={Logout} />
        <Route path="/badges" component={Badges} />
        <Route path="/courses" component={Courses} />
        <Route path="/follow-ups" component={FollowUps} />
        <Route path="/golf-schools" component={GolfSchools} />
        <Route path="/movement-specialists" component={MovementSpecialists} />
        <Route path="/settings" component={Settings} />
        <Route path="/swing-submittals" component={SwingSubmittals} />
        <Route path="/tv" component={Tv} />
        <Route path="/users" component={Users} />
        <Route path="/library" component={Library} />
        <Redirect to="/courses" />
      </Switch>
    </AdminLayout>
  );
};



// WEBPACK FOOTER //
// ./src/App.js